export enum AnalyticsActionsEnum {
  ANALYTICS_GET_DATA = 'ANALYTICS_GET_DATA',
  ANALYTICS_SET_DATA = 'ANALYTICS_SET_DATA',
  ANALYTICS_SET_FILTER = 'ANALYTICS_SET_FILTER',
  ANALYTICS_EXPORT = 'ANALYTICS_EXPORT',
  ANALYTICS_KNM_GET_DATA = 'ANALYTICS_KNM_GET_DATA',
  ANALYTICS_KNM_GET_DATA_NEXT_PAGE = 'ANALYTICS_KNM_GET_DATA_NEXT_PAGE',
  ANALYTICS_KNM_SET_DATA = 'ANALYTICS_KNM_SET_DATA',
  ANALYTICS_KNM_SET_FILTER = 'ANALYTICS_KNM_SET_FILTER',
  ANALYTICS_KNM_SET_ORDER = 'ANALYTICS_KNM_SET_ORDER',
  ANALYTICS_KNM_EXPORT = 'ANALYTICS_KNM_EXPORT',
  ANALYTICS_INIT = 'ANALYTICS_INIT',
}
